import { use_slice_ui } from '@/hooks/store/use_slices';
import { md } from '@/utils/utils_html';
import { DTOworkspacePaymentTransactionStripe } from '@shared/dto/+workspace/workspace_payment_transaction.ts/dto_workspace_payment_transaction_stripe';
import { format_timestamp_YY_MM_DD_HH_mm_ss } from '@shared/utils/utils_time';

interface Props {
  item: DTOworkspacePaymentTransactionStripe;
  index: number;
}

export const USListPaymentsHistoryItem: React.FC<Props> = ({ item, index }) => {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);
  return (
    <div
      className={`${md('px-2 justify-between', 'gap-5 px-5 justify-start')} w-full min-h-[50px] flex flex-row items-center  ${
        index % 2 !== 0 ? 'bg-component-item-selected rounded-lg' : ''
      }`}
    >
      <span className={`${md('w-[45px] text-[9px]', 'w-[120px]')}  text-left`}>{item.status}</span>
      <span className={`${md('w-[55px] text-[12px]', 'w-[120px]')}  text-left`}>
        {item.amount_total} <span className={`${md('text-[9px]', '')}`}>{item.currency}</span>
      </span>
      <span className={`${md('w-[45px] text-[12px]', 'w-[120px]')}  text-left`}>{item.credits_amount}</span>
      <span className={`${md('w-[45px] text-[12px]', 'w-[120px]')}  text-left`}>{item.balance_before}</span>
      <span className={`${md('w-[45px] text-[12px]', 'w-[120px]')}  text-left`}>{item.balance_after}</span>
      <span className={`${md('w-[70px] text-[11px]', 'w-[160px]')}  text-left`}>
        {global_is_mobile ? format_timestamp_YY_MM_DD_HH_mm_ss(item.created_at).split(' ')[0] : format_timestamp_YY_MM_DD_HH_mm_ss(item.created_at)}
      </span>
    </div>
  );
};
